<template>
  <div>
    <v-card v-for="webinar in items" :key="webinar.id" class="mb-5">
      <div v-if="$vuetify.breakpoint.xsOnly">
        <v-img v-if="!webinar.picture" class="user-img" :src="group_cover">
          <span class="status" :class="webinar.status.toLowerCase()">
            {{ webinar.status }}
          </span>
        </v-img>
        <v-img v-else class="user-img" :src="webinar.picture">
          <span class="status" :class="webinar.status.toLowerCase()"
            >{{ webinar.status }}
          </span>
        </v-img>
      </div>
      <div
        :class="
          !$vuetify.breakpoint.xsOnly
            ? 'd-flex d-flex justify-space-between'
            : 'pa-3'
        "
      >
        <!-- <div v-if="$vuetify.breakpoint.xsOnly">

        </div> -->
        <div v-if="!$vuetify.breakpoint.xsOnly">
          <v-img v-if="!webinar.picture" class="user-img" :src="group_cover">
            <span class="status" :class="webinar.status.toLowerCase()">
              {{ webinar.status }}
            </span>
          </v-img>
          <v-img v-else class="user-img" :src="webinar.picture">
            <span class="status" :class="webinar.status.toLowerCase()"
              >{{ webinar.status }}
            </span>
          </v-img>
        </div>
        <div
          style="width: 100%"
          :class="
            !$vuetify.breakpoint.xsOnly
              ? 'pa-3 d-flex justify-space-between flex-column'
              : ''
          "
        >
          <div>
            <div class="d-flex justify-space-between pt-2">
              <div class="title">
                {{ webinar.title }}
              </div>
              <div>
                <span class="level"> {{ webinar.level }}</span>
              </div>
            </div>

            <div class="user-name">
              <span @click="goToProfile(webinar)">
                <!-- class="group-subheader" -->
                By
                <span class="gr-subheader">{{ webinar.owner.name }}</span>
              </span>
            </div>
            <!-- <div>
                <span class="level"> {{ webinar.level }}</span>
              </div> -->
          </div>
          <!-- <div
            v-if="webinar.description.length"
            class="description"
            :class="$vuetify.breakpoint.xsOnly ? 'pt-2' : ''"
          >  
            <span v-if="webinar.description.length < 140">
              {{ webinar.description }}
            </span>
            <span v-else>
              {{ webinar.description.substring(0, 135) }}...     
              <span @click="openReadmore(webinar)" class="description read-more"
                >Read more</span
              >
            </span>
          </div> -->
          <div
            class="description mt-3"
            :class="{ truncated: webinar.description.split(' ').length > 32 }"
            v-html="webinar.description"
          ></div>
          <v-btn
            v-if="webinar.description.split(' ').length > 32"
            color="primary"
            outlined
            rounded
            width="120"
            class="text-none mx-auto"
            @click="openReadmore(webinar)"
            >Read More</v-btn
          >
          <footer
            :class="
              !$vuetify.breakpoint.xsOnly
                ? 'd-flex justify-space-between align-center'
                : 'mt-4'
            "
          >
            <div
              :class="$vuetify.breakpoint.xsOnly ? 'mb-3' : ''"
              class="d-flex align-center"
            >
              <div>
                <v-img class="calendar" :src="webinar_calendar"></v-img>
              </div>
              <span style="height: 50px" class="mx-4">
                <v-divider vertical></v-divider>
              </span>
              <div>
                <div class="event event-date">
                  {{ formattedDate(webinar.date) }}
                </div>
                <div class="event event-time">
                  Starts at {{ formattedTime(webinar.time) }},
                  {{ webinar.duration }} Hr Event
                </div>
              </div>
            </div>
            <div v-if="webinar.status != 'Closed'">
              <RegisterBtn
                v-if="
                  (webinar.status != 'Closed' || webinar.status != 'Ongoing') &&
                  webinar.is_my_webinar == false
                "
                :webinarDetails="webinar"
                :closedWebinarDialog="{}"
              />
            </div>
          </footer>
        </div>
      </div>
    </v-card>
    <WebinarsDetailsModal :openDescription="openDescription" />
  </div>
</template>

<script>
import newAxios from "@/api/newAxios";
import RegisterBtn from "./RegisterBtn.vue";
import WebinarsDetailsModal from "./WebinarsDetailsModal.vue";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat"; // Import custom parse format plugin
import { isAuthenticated } from "@/common/commonFunctions.js";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);

export default {
  name: "WebinarsListComponent",
  components: {
    WebinarsDetailsModal,
    RegisterBtn,
  },

  provide: {},
  data() {
    return {
      items: [],
      group_cover: require("@/assets/images/group_cover_image.svg"),
      user_image: require("@/assets/images/user_webinar_img.svg"),
      webinar_calendar: require("@/assets/images/webinar-calendar.svg"),
      Authentecated: isAuthenticated,
      // open description
      openDescription: {
        flag: false,
        item: "",
      },

      // dummy data
      webinars: [
        {
          id: 2,
          status: "Upcoming",
          owner: {
            profile_image: "",
            name: "Sagar Patel",
          },
          title: "Chhattisgar Stock Exchange",
          level: "Advanced",
          duration: 2,
          description:
            "lorem asjkdfjksadf sadhf asdfhas dfsakhdfkasdfhkasdfhkasjdfksajdfsajdfhaskdjfhas df sadkf sdf askdfh askdhf sajkdf sadfh sakhdf sjdf skdf kjasdf",
          data: "12212123123123",
          time: "09:23",
        },
      ],
    };
  },
  mounted() {
    this.getWebinarList();
  },
  created() {
    this.eventBus.$on("reload-webinar", () => {
      this.getWebinarList();
    });
  },
  beforeDestroy() {
    this.eventBus.$off("reload-webinar");
  },
  methods: {
    openReadmore(item) {
      this.openDescription.item = item;
      this.openDescription.flag = true;
    },
    formattedDate(date) {
      return dayjs(date).format("dddd, D MMMM YYYY");
    },
    formattedTime(time) {
      return dayjs(time, "HH:mm:ss").format("h:mmA");
    },

    goToProfile(user) {
      if (this.Authentecated()) {
        if (user.is_my_webinar) {
          this.$router.push({
            name: "ProfilePage",
          });
        } else {
          this.$router.push({
            name: "OthersProfilePage",
            params: {
              //id:425,
              id: user.owner.id,
              name: user.name,
            },
          });
        }
      } else {
        this.$router.push("login");
      }
    },

    getWebinarList() {
      const onSuccess = (res) => {
        // console.log(res);
        this.items = res.data.message;
      };
      const onFailure = (err) => {
        console.log(err);
      };

      newAxios("get", "trending/get-webinar/", {
        onSuccess,
        onFailure,
        isTokenRequired: this.Authentecated() ? true : false,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.description {
  overflow: hidden;
  position: relative;
  max-height: 3.6em;
  /* Approx height for 3 lines */
}

.description.truncated::after {
  content: "";
  text-align: right;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 1.2em;
  /* Approx height for 1 line */
  background: linear-gradient(to bottom, transparent, white);
}

.read-more {
  color: blue;
  cursor: pointer;
  text-align: center;
}

@media only screen and (max-width: 768px) {
  .title {
    font-size: 16px !important;
    font-weight: 800;
    line-height: 24px !important;
  }

  .user-name {
    font-size: 14px !important;
    font-weight: 500;
    line-height: 19.12px !important;
  }

  .description {
    font-size: 12px !important;
    font-weight: 500;
    line-height: 15px !important;
  }

  .calendar {
    width: 28px !important;
    height: 28px !important;
  }

  .event {
    font-size: 12px !important;
    font-weight: 500;
    line-height: 16.39px !important;
    text-align: left;
  }

  .level {
    font-size: 12px !important;
    font-weight: 500;
    line-height: 16.39px !important;
    text-align: left;
  }

  .user-img {
    width: 100% !important;
    height: 225px !important;
    border-radius: 0px !important;
  }
}

.user-name {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 500;
  line-height: 21.86px;
  text-align: left;
  color: #333333cc;
}

.description {
  font-family: Avenir;
  font-size: 13px;
  font-weight: 500;
  word-break: break-all;
  line-height: 15px;
  text-align: left;
  color: #333333a3;
}

.calendar {
  width: 32px;
  height: 32px;
}

.read-more {
  color: #2f80ed;
  cursor: pointer;
}

.title {
  font-family: Avenir;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  color: #333333;
}

.event {
  font-family: Avenir;
  font-size: 13px;
  font-weight: 500;
  line-height: 17.76px;
  text-align: left;
  color: #333333;
}

.event-date {
}

.event-time {
  color: #333333cc;
}

.gr-subheader:hover {
  text-decoration: underline;
  color: blue;
  cursor: pointer;
}

.level {
  font-family: Avenir;
  font-size: 13px;
  font-weight: 500;
  line-height: 17.76px;
  text-align: left;
  color: #333333;
  background: #ffcf87;
  padding: 4px 8px 4px 8px;
  border-radius: 40px;
  // opacity: 0px;
}

.status {
  position: absolute;
  font-family: Avenir;
  font-size: 13px;
  font-weight: 500;
  line-height: 17.76px;
  text-align: left;
  color: #ffffff;
  padding: 8px 10px 8px 10px;
  border-radius: 8px;
  // opacity: 0px;
  right: 7px;
  top: 7px;
}

.upcoming {
  background: #459cff96;
}

.closed {
  background: #ff222247;
}

.ongoing {
  background: #10ca0047;
}

.user-img {
  width: 384px;
  height: 214px;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}
</style>
